Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.descIsRequired = "Please enter brief description";
exports.shouldBeMinDesc = "The text should be much than 4 symbols";
exports.imageRequired = "Please select image";
